import { HttpClient } from '@angular/common/http';
import {
  Component, OnInit, Inject, LOCALE_ID, ViewChild,
  ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { endOfDay, addMonths } from 'date-fns';
import moment from 'moment';
import * as $ from 'jquery';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService, SelectItem } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { DateFormatModel } from 'src/app/shared/models/common/date-format-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import {
  DAYS_IN_WEEK, SchedulerViewDay, SchedulerViewHour, SchedulerViewHourSegment,
  CalendarSchedulerEvent,
  SchedulerDateFormatter, SchedulerEventTimesChangedEvent,
  CalendarSchedulerViewComponent
} from 'angular-calendar-scheduler';
import { CalendarDateFormatter, CalendarEvent, CalendarView, DAYS_OF_WEEK } from 'angular-calendar';
import { TheraistAppointmentService } from 'src/app/shared/services/theraistappointment.service';
import {
  ExportAppointmentCount, SchedulerMinMaxResponseModel, SchedulerResponseModel,
  SchedulerResponseModelForExport, SchedulerResponseModelForExportFinal
} from '../../../shared/models/response/therapist/therapist-appointments-response-model';
import { takeUntil, finalize } from 'rxjs/operators';
import {
  AppointmentInfoReponseModel, TherapistCustomDatesResponseModel, TherapistEditBlockResponseModel
} from '../../../shared/models/response/appointment/appointment-info-reponse-model';
import { WIPStatesResponseModel } from '../../../shared/models/response/appointment/wip-states-response-model';
import { Constants } from '../../../shared/constants';
import { RCMCofigurationUrl } from '../../../shared/models/response/settings/settings-plugin-response-model';
import { ResultOfT } from '../../../shared/models/response/result';
import { FeatureGroupService } from '../../../shared/services/featuregroup.service';
import { WipStatusBTmapping } from '../../../shared/models/common/wip-status';
import { QuickFilters } from '../../../shared/models/common/custom-filiters';
import { DomSanitizer } from '@angular/platform-browser';
import { EventAction } from 'calendar-utils';
import { Accordion } from 'primeng/accordion';
import { AdminCustomSettingsResponseModel, SettingsResponseModel } from '../../../shared/models/response/appointment/settings-response';
import { TherapistResponseModel } from 'src/app/shared/models/response/therapist/therapist-response-model';
import { BranchResponseModel } from 'src/app/shared/models/response/branch-response-model';
import { FacilityInfoResponseModel } from 'src/app/shared/models/response/facility/facilityinfo-response-model';
import { TherapistAppointmentSearchRequestModel } from 'src/app/shared/models/request/therapist/therapist-appointment-request-model';
import { FacilityService } from '../../servicies/facility.service';
import { AppointmentService } from '../../servicies/appointment.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NearByPatientResponseModel } from 'src/app/shared/models/response/appointment/nearby-patient-response-model';
import { User, GroupPatientOption } from '../therapist-day-view-scheduler-v1/day-view-scheduler-v1.component';
import { BookAppointmentInfoComponent } from '../../book-appointment-info/book-appointment-info.component';
import { TwilioDeviceObject } from 'src/app/shared/models/common/twilio-device-object';
import { TwillioCallService } from '../../servicies/twillioCall.service';
import * as _ from 'lodash';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { isSameDay, isBefore, isAfter } from 'date-fns';
import { AdminSettingsService } from '../../servicies/admin-settings.service';
import { RemoteAppointmentTypeModel } from 'src/app/shared/models/response/appointment/remote-appointment-type-model';
import { TherapistCustomAvailabilityResponseModel } from 'src/app/shared/models/response/therapist/therapist-custom-availability-response-model';
import { ManageAvailabilityService } from '../../servicies/manage-availability.service';
import { FilterClassificationTypeResponseModel } from 'src/app/shared/models/response/appointment/filter-classification-response-model';
// import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
// (pdfMake as any).vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts;


import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts;

const colors: any = {
  red: { primary: '#ad2121', secondary: '#FAE3E3' },
  yellow: { primary: '#e3bc08', secondary: '#FDF1BA' },
  green: { primary: '#D0F6DB', secondary: '#D0F6DB' },
  purple: { primary: '#e3deff', secondary: '#e3deff' },
  blue: { primary: '#EDEAFF', secondary: '#EDEAFF' },
  grey: { primary: '#D0F6DB', secondary: '#D0F6DB' },
  lightGrey: { primary: '#dbdbdb', secondary: '#dbdbdb' },
  darkGrey: { primary: '#cbcbcb', secondary: '#cbcbcb' },
  transparent: { primary: '#ffffff00', secondary: '#ffffff00' },
  orange: { primary: '#F9F9F9', secondary: '#F9F9F9' },
  blokSlot: { primary: '#d1e8ff', secondary: '#d1e8ff' },
};

@Component({
  selector: 'app-week-by-therapist-scheduler-v1',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './week-by-therapist-scheduler-v1.component.html',
  styleUrls: ['./week-by-therapist-scheduler-v1.component.sass'],
  providers: [
    { provide: CalendarDateFormatter, useClass: SchedulerDateFormatter },
    DialogService
  ],
  standalone: false
})
export class WeekByTherapistSchedulerV1Component extends BaseComponent implements OnInit {

  schedulerList: SchedulerResponseModel[];
  appointmentInfoReponseModel: SchedulerResponseModel;
  appointment: AppointmentInfoReponseModel;
  duration: string;
  comments: string;
  wipStatus: any;
  wipStatesId: number;
  salesOrderStatus: WIPStatesResponseModel[];
  salesOrderStatusCurrent: WIPStatesResponseModel[];
  salesOrderType: string = 'AppointmentRequest';
  patientBrighttreeURL: any;
  salesOrderBrighttreeURL: any;
  brightreeInternalUserId: number;
  wipStatusBTMappingResponseModel: WipStatusBTmapping[];
  _patientTimezone: string = '';

  view: CalendarView = CalendarView.Week;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  viewDays: number = DAYS_IN_WEEK;
  refresh: Subject<any> = new Subject();
  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();
  locale: string = 'en';
  hourSegments: number = 4;
  weekStartsOn: number = 0;
  weekStartsOn1: number = DAYS_OF_WEEK.SUNDAY;
  startsWithToday: boolean = false;
  activeDayIsOpen: boolean = true;
  excludeDays: number[] = [];
  weekendDays: number[] = [0, 6];
  dayStartHour: number = 7;
  dayEndHour: number = 19;
  selectedAppointments: string[];

  minDate: Date = new Date();
  maxDate: Date = endOfDay(addMonths(new Date(), 1));

  dayModifier: Function;
  hourModifier: Function;
  segmentModifier: Function;
  eventModifier: Function;

  prevBtnDisabled: boolean = true;
  nextBtnDisabled: boolean = true;

  therapistId: number;
  therapistName: string;
  appDateFormat: DateFormatModel;
  selectedDayViewDate: Date;
  en: any;
  currentSelectedView: any;
  dateFormat: string = '';
  primeFormat: string = '';
  timeZone: string = '';
  Customloading: boolean = false;
  isShowModel: boolean = false;
  isShowStatusDropdown: boolean = false;
  canStatusIsUpate: boolean = false;
  selectedcalendarActions: QuickFilters;
  calendarActions: QuickFilters[];
  twoFacilityPopup: boolean = false;
  activeState: boolean[] = [true, false, false, false];
  facilityTimeZone: string = '';
  isBrightreeSystemAppUpdate: Boolean = true;
  isBrightreeSystemAppUpdateSetting: Boolean = false;
  selectedTherapists: TherapistResponseModel;
  selectedbranches: BranchResponseModel[];
  selectedAppointmentFacilities: FacilityInfoResponseModel[];
  therapistResponseModel: TherapistResponseModel[];
  crmselectedTimeZone: string = 'UTC-5';
  isShowHomeVisit: boolean = false;
  branchResponseModel: BranchResponseModel[];
  selectedbranch: BranchResponseModel;
  facilityResponseModel: FacilityInfoResponseModel[];
  selectedFacilities: FacilityInfoResponseModel[];
  isBlankMessageforTherapistShow: boolean = false;
  isBranchChange: boolean = false;
  redirectedFacilityIdNumber: number;
  selectedFacility: FacilityInfoResponseModel;
  pageTitle: string;
  facilityId: number;
  isBlankMessageshow: boolean = false;
  currentUserBranch: number;
  selectedApptType: string = '';
  fillSlotPopup: boolean = false;
  isFacilityselected: boolean = false;
  searchedFacilityid: number = 0;
  facilityName: string;
  remoteFacilityName: string;
  isRemoteOnly: boolean = false;
  IsRemoteOrFacility: number = 0;
  searchDate: Date;
  currentDate: Date;
  isRemoteAndFacility: boolean = false;
  remoteFacilityId: number;
  isStartFromDefaultFacility: boolean;
  isStartFromHomeAddress: boolean;
  selectedFacilityTimeZone: string;
  nearByPatients: NearByPatientResponseModel[];
  origionalNearByPatients: NearByPatientResponseModel[];
  selectedFilSlotDateTime: Date;
  isRightPanelEnabled: boolean = false;
  isRightPanelBlockEnabled: boolean = false;
  selectUser: User;
  searchText: string = '';
  searchUser: User;
  showClear: boolean = false;
  isBillingAddress: boolean = false;
  blockSlotPopup: boolean;
  isBlock: boolean;
  availId: number;
  therapistCustomAvailabilityId: number;
  labelFor: string;
  therapisId: number;
  selectedtherapist: string;
  customStartTime: string;
  customEndTime: string;
  selectedAppointment: AppointmentInfoReponseModel;
  defaultModeofAppointment: string = '';
  maxDateToDisplay: Date;
  isDisabledReassignment: boolean = true;
  selectFacilityString: string = '0';
  selectBranchString: string = '0';
  selectTherapistString: string = '0';
  events$: Observable<CalendarEvent<{ appointmentInfoReponseModel: SchedulerResponseModel }>[]>;
  users: User[];
  selectedUser: User|null;
  isHoliday: boolean = false;
  holidayMessage: string;
  ESTTherapistCount: number = 0;
  CSTTherapistCount: number = 0;
  MSTTherapistCount: number = 0;
  PSTTherapistCount: number = 0;
  AMSTTherapistCount: number = 0;
  timeZoneShortCode: string = 'UTC-5';
  timeZoneCodeTherapistCount: number = 0;
  dayStartMinute: number = 0;
  dayEndMinute: number = 59;
  dayEnd: number;
  dayStart: number;
  isChangeRemoteAppointmentType: boolean = false;
  convertedRemoteAppointmentType: string;
  remoteAppointmentTypeResponseModel: Array<RemoteAppointmentTypeModel>;
  selectedAppointmentStatus: SelectItem;
  selectedAppointmentValues: string[] = [];
  blockDesc: string;
  isButtonDisabled: boolean = false;
  isRoadHomeAppt: boolean = false;
  loggedInUserId: number;
  loadingBlockSlotBrakHours: boolean = false;
  daysToShow: number;
  weekStartDate: string;
  weekEndDate: string;
  currentYear: string;
  isNextButtonDisable: boolean = false;
  previousDate: string;
  exportDataRes: SchedulerResponseModelForExport[];

  actions: EventAction[] = [
    {
      label: '<span class="valign-center edit-btn-block"><i class="edit-icon-new"></i></span>',
      onClick: ({ event }: { event: CalendarEvent }): void => { }
    }
  ];

  events: CalendarEvent[];

  @ViewChild('calendarScheduler', { static: false }) calendarScheduler: CalendarSchedulerViewComponent;
  @ViewChild('accordion') accordion: Accordion;

  timeZoneList: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string }[];
  selectedTimeZone: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string };
  slotTimeZone: { name: string; code: string; shortName: string; displayName: string; countryName: string };
  TimeSelectionList: { name: string }[] = [];
  StartTimeSelections: { name: string }[];
  EndTimeSelections: { name: string }[];
  InfoSidebar: boolean = false;
  LegendsisActive: boolean;
  therapistCustomDateId: number;
  exportAppointmentCnt: ExportAppointmentCount[];
  filterClassificationList: FilterClassificationTypeResponseModel[];
  selectedClassificationType: FilterClassificationTypeResponseModel[] = [];
  isAllClssificationFilterSelected: boolean = true;
  isAllBranchFilterSelected: boolean = true;
  selectedFilterBranches: BranchResponseModel[] = [];
  isFilterSubmit: boolean = false;
  isClassificationMapped = true;


  patientSelect: GroupPatientOption[] = [];
  selectedPatientPerGroup: Map<string, GroupPatientOption> = new Map();
  isGroupAppointment: boolean = false;
  facilityInfo: TherapistCustomDatesResponseModel;
  bookedGroupAppointmentType: string = '';
  maxLimitReached: boolean = false;



  isGroupAppointmentSelected(calEvent: any): boolean {
    return calEvent?.meta?.user?.isGroupAppointmentUser && calEvent?.meta?.appointmentInfoReponseModel?.appointment?.appointmentGroupId != null;

  }

  getGroupPatients(appointmentGroupId: string): GroupPatientOption[] {
    return this.patientSelect.filter(
      (x) => String(x.appointmentGroupId) === String(appointmentGroupId)
    );
  }


  getSelectedPatientOption(appointmentGroupId: string): GroupPatientOption | null {
    const key = String(appointmentGroupId);
    const stored = this.selectedPatientPerGroup.get(key);
    if (stored) return stored;
    const first = this.getGroupPatients(key)[0] ?? null;
    if (first) this.selectedPatientPerGroup.set(key, first);
    return first;
  }


  onGroupPatientChange(option: GroupPatientOption, appointmentGroupId: string): void {
    if (!option) return;
    this.selectedPatientPerGroup.set(String(appointmentGroupId), option);
    this.cdr.markForCheck();
  }

  private getActiveCalEvent(calEvent: any): any {
    if (!this.isGroupAppointmentSelected(calEvent)) return calEvent;
    const opt = this.getSelectedPatientOption(String(calEvent.appointmentGroupId));
    return opt?.event ?? calEvent;
  }

  getActiveEventObject(calEvent: any): any {
    if (!this.isGroupAppointmentSelected(calEvent)) {
      return calEvent?.meta?.eventObject;
    }

    const opt = this.getSelectedPatientOption(String(calEvent.appointmentGroupId));
    return opt?.event ?? calEvent?.meta?.eventObject;
  }

  getActiveAppointment(calEvent: any): any {
    if (!this.isGroupAppointmentSelected(calEvent)) {
      return calEvent?.meta?.appointmentInfoReponseModel?.appointment;
    }

    const activeEventObject = this.getActiveEventObject(calEvent);
    return activeEventObject?.appointment ?? calEvent?.meta?.appointmentInfoReponseModel?.appointment;
  }

  getActiveAppointmentType(calEvent: any): string {
    return this.getActiveAppointment(calEvent)?.crmAppointmentType
      ?? calEvent?.meta?.appointmentInfoReponseModel?.appointment?.crmAppointmentType
      ?? '';
  }

  getActiveClassification(calEvent: any): string {
    const evObj = this.getActiveEventObject(calEvent);
    return evObj?.crmClassificationDisplayName
      ?? calEvent?.meta?.eventObject?.crmClassificationDisplayName
      ?? '';
  }

  getActiveAppointmentTypeLabel(calEvent: any): string {
    return this.getActiveEventObject(calEvent)?.appointmentType
      ?? calEvent?.meta?.eventObject?.appointmentType
      ?? '';
  }

  getActiveStartLabel(calEvent: any): any {
    return this.getActiveEventObject(calEvent)?.startLabel
      ?? calEvent?.meta?.eventObject?.startLabel;
  }

  getActiveEndLabel(calEvent: any): any {
    return this.getActiveEventObject(calEvent)?.endLabel
      ?? calEvent?.meta?.eventObject?.endLabel;
  }

  getActivePatientTimeZone(calEvent: any): string {
    const tz = this.getActiveEventObject(calEvent)?.crmPatientTimeZone;
    if (tz && tz !== 'null') return tz;
    return calEvent?.meta?.eventObject?.crmPatientTimeZone ?? '';
  }

  getActiveSalesOrderAppId(calEvent: any): string {
    return this.getActiveEventObject(calEvent)?.appointment?.crmSalesorderAppId
      ?? calEvent?.meta?.eventObject?.appointment?.crmSalesorderAppId
      ?? '';
  }

  getActivePatientRcmId(calEvent: any): string {
    return this.getActiveAppointment(calEvent)?.crmPatientRcmBrightreeID
      ?? calEvent?.meta?.appointmentInfoReponseModel?.appointment?.crmPatientRcmBrightreeID
      ?? '';
  }

  getActivePatientId(calEvent: any): string {
    return this.getActiveAppointment(calEvent)?.crmPatientId
      ?? calEvent?.meta?.appointmentInfoReponseModel?.appointment?.crmPatientId
      ?? '';
  }

  getActivePatientName(calEvent: any): string {
    return this.getActiveCalEvent(calEvent)?.title
      ?? calEvent?.title
      ?? '';
  }

  getActiveFacilityName(calEvent: any): string {
    return this.getActiveAppointment(calEvent)?.crmFacilityName
      ?? calEvent?.meta?.appointmentInfoReponseModel?.appointment?.crmFacilityName
      ?? '';
  }

  getActiveBookedBy(calEvent: any): number {
    if (this.isGroupAppointmentSelected(calEvent)) {
      const groupId = calEvent?.appointmentGroupId ?? calEvent?.meta?.appointmentGroupId ?? calEvent?.meta?.appointmentInfoReponseModel?.appointmentGroupId;
      const selectedOption = this.getSelectedPatientOption(String(groupId));
      if (selectedOption?.event?.appointment?.schAppointmentBookedBy !== undefined) {
        return selectedOption.event.appointment.schAppointmentBookedBy;
      }
    }
    return calEvent?.meta?.appointmentInfoReponseModel?.appointment?.schAppointmentBookedBy;
  }


  showDialogPopupForEvent(
    data,
    calEvent: any,
    overlaypanelContextMenu: OverlayPanel,
    overlaypanelBlockSlot: OverlayPanel
  ): void {
    this.searchUser = calEvent?.meta?.user ?? null;
    this.searchDate = calEvent?.start ?? null;
    const appointment = this.getActiveAppointment(calEvent);

    let startDate = moment(calEvent.start).toDate();
    let facilityInfo: TherapistCustomDatesResponseModel = calEvent?.meta?.user?.distinctTherapistAvailability.find(
      (x) => startDate >= moment(x.crmStartTime).add(-1, 'minutes').toDate()
        && startDate <= moment(x.crmEndTime).add(-1, 'minutes').toDate());

    if (facilityInfo) {
      this.facilityId = facilityInfo.facilityId;
      this.isRemoteAndFacility = facilityInfo.isRemoteAndFacility;
      this.remoteFacilityId = facilityInfo.remoteFacilityId;
      this.isFacilityselected = !facilityInfo.isRemoteAndFacility;
    }

    this.maxLimitReached = false;

    if (this.isGroupAppointmentSelected(calEvent) && calEvent.appointmentGroupId != null) {
      let bookedAppointmentsCount = calEvent?.meta?.groupMembers?.length ?? 0;
      let maxAppts = calEvent?.meta?.maxAppointmentsInGroup ?? 0;
      if (maxAppts > 0 && bookedAppointmentsCount >= maxAppts) {
        this.maxLimitReached = true;
      }
    }

    let groupAppointmentType = this.getActiveAppointmentType(calEvent);
    this.showDialogPopup(true, appointment, overlaypanelContextMenu, overlaypanelBlockSlot, this.isGroupAppointmentSelected(calEvent), facilityInfo, groupAppointmentType);
  }

  private buildGroupState(events: CalendarEvent[]): void {
    this.patientSelect = [];

    events.forEach((evt: any) => {
      if (evt.appointmentGroupId == null || !evt.meta?.groupMembers) return;

      const groupMembers = evt.meta.groupMembers;
      const groupId = String(evt.appointmentGroupId);

      groupMembers.forEach((member: any) => {
        this.patientSelect.push({
          name: member.title,
          appointmentGroupId: groupId,
          appointmentId: member.id,
          event: member
        });
      });

      if (!this.selectedPatientPerGroup.has(groupId)) {
        const defaultOption = this.patientSelect.find(
          (o) => String(o.appointmentGroupId) === groupId && o.appointmentId === groupMembers[0].id
        );
        if (defaultOption) {
          this.selectedPatientPerGroup.set(groupId, defaultOption);
        }
      }
    });
  }

  constructor(
    protected cdr: ChangeDetectorRef,
    private webStorageService: WebStorageService,
    private router: Router,
    messageService: MessageService,
    private titleService: Title,
    private dialougeService: DialogService,
    private theraistAppointmentService: TheraistAppointmentService,
    @Inject(LOCALE_ID) locale: string,
    private sanitizer: DomSanitizer,
    private featureGroupService: FeatureGroupService,
    private facilityService: FacilityService,
    private appointmentService: AppointmentService,
    private twillioCallService: TwillioCallService,
    private http: HttpClient,
    private settingsService: AdminSettingsService,
    private therapistService: ManageAvailabilityService,
  ) {
    super(messageService);

    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.brightreeInternalUserId = loggedInUser.crmBrightreeUserId;
    this.currentUserBranch = this.webStorageService.getUserBranch();
    this.appDateFormat = this.webStorageService.getDateFormat();
    this.loading = false;
    this.titleService.setTitle('Appoint360');
    this.locale = locale;

    this.segmentModifier = ((segment: SchedulerViewHourSegment): void => {
      segment.isDisabled = false;
    }).bind(this);

    this.eventModifier = ((event: CalendarSchedulerEvent): void => {
      event.isDisabled = false;
    }).bind(this);

    this.calendarActions = [
      { name: 'Week View By Therapist', code: 'WeekByTherapist' },
      { name: 'View By Therapist', code: 'ViewByTherapist' },
      { name: 'View By Date', code: 'ViewByDate' },
    ];

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const h = (hour % 12 || 12).toString().padStart(2, '0');
        const m = minute.toString().padStart(2, '0');
        const p = hour < 12 ? 'am' : 'pm';
        this.TimeSelectionList.push({ name: `${h}:${m} ${p}` });
      }
    }
    this.StartTimeSelections = [...this.TimeSelectionList];
    this.EndTimeSelections = [...this.TimeSelectionList];
    this.webStorageService.getClientConfig();
  }


  async ngOnInit(): Promise<void> {
    this.fillSlotPopup = false;
    const currentDate = new Date(this.weekcurrentDate.replace(/-/g, '/'));
    const weekStart = moment(currentDate).startOf('week').toDate();
    const weekEnd = moment(currentDate).endOf('week').toDate();
    this.weekStartDate = moment(weekStart).format('MMMM DD');
    this.weekEndDate = moment(weekEnd).format('MMMM DD');
    this.currentYear = moment(weekEnd).format('YYYY');

    this.timeZoneList = [
      { name: 'Eastern Time (UTC -5:00)', code: 'UTC -5', shortName: 'EST', orgcode: 'UTC-5', displayName: 'EST', countryName: 'America/New_York' },
      { name: 'Central Time (UTC -6:00)', code: 'UTC -6', shortName: 'CST', orgcode: 'UTC-6', displayName: 'Central', countryName: 'America/Chicago' },
      { name: 'Mountain Time (UTC -7:00)', code: 'UTC -7', shortName: 'MST', orgcode: 'UTC-7', displayName: 'Mountain', countryName: 'America/Boise' },
      { name: 'Arizona Mountain Time (UTC -7:00)', code: 'UMST -7', shortName: 'AMST', orgcode: 'UMST-7', displayName: 'Mountain', countryName: 'America/Phoenix' },
      { name: 'Pacific Time (UTC -8:00)', code: 'UTC -8', shortName: 'PST', orgcode: 'UTC-8', displayName: 'Pacific', countryName: 'America/Los_Angeles' },
      { name: 'Hawaiian Standard Time (UTC -10:00)', code: 'UTC -10', orgcode: 'UTC-10', shortName: 'HST', displayName: 'Hawaiian', countryName: 'Pacific/Honolulu' }
    
    ];

    this.selectedcalendarActions = this.calendarActions.find(x => x.code === 'WeekByTherapist');

    this.en = {
      firstDayOfWeek: 0,
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today', clear: 'Clear',
      dateFormat: this.appDateFormat.dateFormat, weekHeader: 'Wk'
    };

    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      this.therapistId = currentUserToken.userId;
      this.therapistName = currentUserToken.userFullName;
      this.facilityTimeZone = currentUserToken.crmTimeZone;
    } else {
      this.therapistId = 0;
      this.therapistName = '';
      this.facilityTimeZone = this.selectedTherapists?.facilityTimeZone ?? '';
    }

    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.loggedInUserId = loggedInUser.userId;
    this.events = [];
    this.selectedTherapists = null;

    await this.getSettingInit();
    await this.getBranches();
    await this.GetFacilitiesByBranchIds();
    await this.GetAllAvailableTherapistByBranchAndDate();
    await this.GetAllTherapistForAppointmentsByTimeZone();
    this.getGlobalTimeZone();
    this.GetRCMConfigurationUrl();
    this.exportData(true);

    if (!this.LegendsisActive) { $('body').removeClass('show-legends'); }
  }


  async fetchEvents(isRefresh: boolean) {
    this.appointment = new AppointmentInfoReponseModel();

    let clientId = '';
    let Authorization = '';
    const currentClientConfig = this.webStorageService.getClientConfig();
    if (currentClientConfig?.companyId) { clientId = currentClientConfig.companyId.toString(); }

    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      Authorization = currentUserAuthToken.tokentype.concat(' ').concat(currentUserAuthToken.token);
    }

    let selectBranchString = '';
    let selectFacilityString = '';
    let selectTherapistString = '';
    const branchIds: number[] = [];
    this.selectedbranches.forEach(v => { selectBranchString += v.crmBranchId + ','; branchIds.push(v.crmBranchId); });

    const therpistIds: number[] = [];
    if (this.selectedTherapists) {
      therpistIds.push(this.selectedTherapists.appUserInfoId);
      selectTherapistString = this.selectedTherapists.appUserInfoId + ',';
    }

    const facilityids: number[] = [];
    this.selectedAppointmentFacilities.forEach(v => { selectFacilityString += v.crmFacilityId + ','; facilityids.push(v.crmFacilityId); });

    if (this.isShowHomeVisit) {
      this.selectFacilityString = '0';
      facilityids.push(0);
    }

    const req = new TherapistAppointmentSearchRequestModel();
    const selectedDate = this.weekcurrentDate;
    req.appointmentDate = selectedDate;
    req.crmBranchIds = branchIds;
    req.crmFacilityiIds = facilityids;
    req.crmTherapistsId = therpistIds;
    req.crmBranchIdsString = selectBranchString;
    req.crmFacilityiIdsString = selectFacilityString;
    req.crmTherapistsIdString = selectTherapistString;
    req.crmselectedTimeZone = this.selectedTherapists?.facilityTimeZone ?? this.crmselectedTimeZone;

    this.loadingCustom = true;
    await this.therapistService.GetWeekViewTherapistAppointmentWeekViewDME(
      selectedDate, req, selectTherapistString, selectBranchString, selectFacilityString, isRefresh
    )
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loadingCustom = false))
      .toPromise()
      .then((result) => {
        this.processResult<SchedulerResponseModel[]>(result, () => {
          if (result.isSuccess) {
            const lstCalendarSchedulerEvent: CalendarEvent[] = [];
            let hasAnyAppointment = false;

            const groupedAppointments = _.groupBy(
              result.responseModel.filter(x => x.appointmentGroupId != null),
              (x) => String(x.appointmentGroupId)
            );

            const individualAppointments = result.responseModel.filter(x => x.appointmentGroupId == null);

            individualAppointments.forEach(x => {
              let is15min = false;
              if (x.appointment) {
                hasAnyAppointment = true;
                const diff = moment(x.end).diff(moment(x.start), 'minutes');
                if (diff <= 15) is15min = true;
              }
              if (x.isBlock) hasAnyAppointment = true;

              const _facilityTimeZone = x.facilityTimeZone ? String(x.facilityTimeZone) : '';
              const _crmPatientTimeZone = x.crmPatientTimeZone ? String(x.crmPatientTimeZone) : '';

              x.is15minSlot = is15min;
              const eventObject: any = x;
              eventObject.startLabel = moment(x.startLabel, 'YYYY-MM-DD HH:mm').toDate();
              eventObject.endLabel = moment(x.endLabel, 'YYYY-MM-DD HH:mm').toDate();
              eventObject.isSystemBlock = x?.isSystemBlock === true;

              lstCalendarSchedulerEvent.push({
                id: Number(x.id),
                start: moment(x.start, 'YYYY-MM-DD HH:mm').toDate(),
                end: moment(x.end, 'YYYY-MM-DD HH:mm').toDate(),
                title: x.title,
                meta: {
                  eventObject,
                  appointmentInfoReponseModel: x,
                  user: this.selectedUser,
                  isSystemBlock: x?.isSystemBlock === true,
                },
                color: Number(x.id) === 0 ? colors.grey : Number(x.id) === -1 ? colors.blokSlot : colors.blue,
                actions: Number(x.id) > 0 ? this.actions : null,
              } as any);
            });

            Object.keys(groupedAppointments).forEach(groupId => {
              const groupEvents = groupedAppointments[groupId];
              if (groupEvents.length === 0) return;

              const primaryEvent = groupEvents[0];
              hasAnyAppointment = true;

              let is15min = false;
              if (primaryEvent.appointment) {
                const diff = moment(primaryEvent.end).diff(moment(primaryEvent.start), 'minutes');
                if (diff <= 15) is15min = true;
              }

              const _facilityTimeZone = primaryEvent.facilityTimeZone ? String(primaryEvent.facilityTimeZone) : '';
              const _crmPatientTimeZone = primaryEvent.crmPatientTimeZone ? String(primaryEvent.crmPatientTimeZone) : '';

              primaryEvent.is15minSlot = is15min;
              const eventObject: any = primaryEvent;
              eventObject.startLabel = moment(primaryEvent.startLabel, 'YYYY-MM-DD HH:mm').toDate();
              eventObject.endLabel = moment(primaryEvent.endLabel, 'YYYY-MM-DD HH:mm').toDate();
              eventObject.isSystemBlock = primaryEvent?.isSystemBlock === true;

              lstCalendarSchedulerEvent.push({
                id: Number(primaryEvent.id),
                appointmentGroupId: primaryEvent.appointmentGroupId, // Group ID on event root
                start: moment(primaryEvent.start, 'YYYY-MM-DD HH:mm').toDate(),
                end: moment(primaryEvent.end, 'YYYY-MM-DD HH:mm').toDate(),
                title: primaryEvent.title, // Default title (will be overridden by active selection)
                meta: {
                  eventObject,
                  appointmentInfoReponseModel: primaryEvent,
                  user: this.selectedUser,
                  isSystemBlock: primaryEvent?.isSystemBlock === true,
                  appointmentGroupId: primaryEvent.appointmentGroupId,
                  maxAppointmentsInGroup: primaryEvent.maxAppointmentsInGroup,
                  groupMembers: groupEvents.map(member => {
                    const processedMember = { ...member };
                    processedMember.startLabel = moment(member.startLabel, 'YYYY-MM-DD HH:mm').toDate();
                    processedMember.endLabel = moment(member.endLabel, 'YYYY-MM-DD HH:mm').toDate();
                    processedMember.is15minSlot = is15min;
                    processedMember.isSystemBlock = member?.isSystemBlock === true;
                    return processedMember;
                  })
                },
                color: Number(primaryEvent.id) === 0 ? colors.grey : Number(primaryEvent.id) === -1 ? colors.blokSlot : colors.blue,
                actions: Number(primaryEvent.id) > 0 ? this.actions : null,
              } as any);
            });

            this.events = lstCalendarSchedulerEvent;

            if (hasAnyAppointment) {
              this.isBlankMessageforTherapistShow = false;
            }

            this.buildGroupState(this.events);

            this.cdr.detectChanges();

            const el = document.getElementsByClassName('material-icons md-32')[0];
            if (el && this.selectedTherapists) {
              el.innerHTML = this.timeZoneList.find(
                x => x.orgcode === this.selectedTherapists.facilityTimeZone
              )?.shortName ?? '';
            }
          }
        });
      });
  }

  private async GetAllTherapistForAppointmentsByTimeZone() {
    this.isHoliday = false;
    this.holidayMessage = '';

    let selectBranchString = '';
    let selectFacilityString = '';
    let selectTherapistString = '';

    this.selectedAppointments = [];
    const branchIds: number[] = [];
    this.selectedbranches.forEach(v => { selectBranchString += v.crmBranchId + ','; branchIds.push(v.crmBranchId); });

    const therpistIds: number[] = [];
    if (this.selectedTherapists) therpistIds.push(this.selectedTherapists.appUserInfoId);

    const facilityids: number[] = [];
    this.selectedAppointmentFacilities.forEach(v => { selectFacilityString += v.crmFacilityId + ','; facilityids.push(v.crmFacilityId); });

    this.ESTTherapistCount = this.CSTTherapistCount = this.MSTTherapistCount = this.PSTTherapistCount = this.AMSTTherapistCount = 0;

    const req = new TherapistAppointmentSearchRequestModel();
    const selectedDate = this.weekcurrentDate;
    req.appointmentDate = selectedDate;
    req.crmBranchIds = branchIds;
    req.crmFacilityiIds = facilityids;
    req.crmTherapistsId = therpistIds;
    req.crmBranchIdsString = selectBranchString;
    req.crmFacilityiIdsString = selectFacilityString;
    req.crmTherapistsIdString = selectTherapistString;
    req.crmselectedTimeZone = this.selectedTherapists?.facilityTimeZone ?? this.crmselectedTimeZone;

    this.selectedAppointments = [];
    this.loadingCustom = true;

    await this.therapistService.GetAllTherapistForAppointmentsWeekViewDME(req)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loadingCustom = false))
      .toPromise()
      .then((result) => {
        this.users = [];

        if (result.isSuccess) {
          this.loadingCustom = false;

          // ── Timezone counts ─────────────────────────────────────────────
          const tzModel = result.responseModel?.schedulerTimeZoneResponseModel;
          if (tzModel) {
            this.ESTTherapistCount = tzModel.find(x => x.timeZone === 'UTC-5')?.therpiastCount ?? 0;
            this.CSTTherapistCount = tzModel.find(x => x.timeZone === 'UTC-6')?.therpiastCount ?? 0;
            this.MSTTherapistCount = tzModel.find(x => x.timeZone === 'UTC-7')?.therpiastCount ?? 0;
            this.PSTTherapistCount = tzModel.find(x => x.timeZone === 'UTC-8')?.therpiastCount ?? 0;
            this.AMSTTherapistCount = tzModel.find(x => x.timeZone === 'UMST-7')?.therpiastCount ?? 0;
          }

          // ── Build User objects ──────────────────────────────────────────
          result.responseModel.schedulerResponseModel.forEach(value => {
            const startDate = moment(value.startLabel, 'YYYY-MM-DD HH:mm').toDate();
            const startDateExt = moment(startDate, 'YYYY-MM-DD HH:mm').add(-1, 'minutes');
            const endDate = moment(value.endLabel, 'YYYY-MM-DD HH:mm').toDate();
            const endDateExt = moment(endDate, 'YYYY-MM-DD HH:mm').add(-1, 'minutes');

            const user = new User();
            user.id = value.id;
            user.field = value.field;
            user.name = value.title;
            user.start = startDateExt.toDate();
            user.end = endDateExt.toDate();
            user.therapistCustomAvailabilityId = value.therapistCustomAvailabilityId;
            user.therapistCustomDateId = value.therapistCustomDateId;
            user.startDate = startDate;
            user.endDate = endDate;
            user.origStart = moment(value.start, 'YYYY-MM-DD HH:mm').toDate();
            user.origEnd = moment(value.end, 'YYYY-MM-DD HH:mm').toDate();
            user.therapistAvailability = value.therapistAvailability;
            user.practionaerId = value.practitionerId;
            user.deliveryTechnicianId = value.deliveryTechnicianId;
            user.isGroupAppointmentUser = value.isGroupAppointmentUser;
            const facilityTimeZone = value.therapistAvailability.find(x => x.facilityTimeZone);
            if (facilityTimeZone) user.facilityTimeZone = facilityTimeZone.facilityTimeZone;

            const removeBlankFacility = value.therapistAvailability.filter(x => x.facilityName !== '');
            const therapistAvailabilityFilter: TherapistCustomDatesResponseModel[] = [];
            for (const item of removeBlankFacility) {
              const _model: any = item;
              const facilityFilter = this.facilityResponseModel?.find(x => x.crmFacilityId === item.facilityId);
              if (!_model.isStartFromDefaultFacility && !_model.isStartFromHomeAddress) {
                if (facilityFilter?.isRemoteAssistance) _model.facilityTimeZone = '';
                else if (!facilityFilter) _model.facilityTimeZone = '';
              }
              therapistAvailabilityFilter.push(_model);
            }
            user.distinctTherapistAvailability = therapistAvailabilityFilter;
            this.users.push(user);
          });

          // ── Set selectedUser ────────────────────────────────────────────
          if (this.selectedTherapists) {
            this.selectedUser = this.users.find(x => x.id === this.selectedTherapists.appUserInfoId) ?? null;
          } else {
            this.selectedUser = null;
          }

          if (this.users.length > 0 && this.selectedUser) {
            this.isBlankMessageforTherapistShow = false;

            // ── Compute calendar day start/end from selected user ─────────
            const selecteduser = this.selectedUser;
            const currDate = moment(new Date()).format('YYYY-MM-DD');
            const CustomData: SchedulerMinMaxResponseModel[] = [];

            selecteduser.distinctTherapistAvailability.forEach(item => {
              const startTime = moment(item.crmStartTime).format('HH:mm:ss');
              const endTime = moment(item.crmEndTime).format('HH:mm:ss');
              const c1 = new SchedulerMinMaxResponseModel();
              c1.startTime = moment(currDate + ' ' + startTime, 'YYYY-MM-DD HH:mm').toDate();
              c1.endTime = moment(currDate + ' ' + endTime, 'YYYY-MM-DD HH:mm').toDate();
              CustomData.push(c1);
            });

            if (CustomData.length > 0) {
              const mnDate = CustomData.map(d => d.startTime).reduce((a, b) => a < b ? a : b);
              const mxDate = CustomData.map(d => d.endTime).reduce((a, b) => a > b ? a : b);
              const _s = moment(mnDate, 'YYYY-MM-DD HH:mm').toDate();
              const _e = moment(mxDate, 'YYYY-MM-DD HH:mm').toDate();
              this.dayStartHour = _s.getHours();
              this.dayStartMinute = _s.getMinutes();
              this.dayEndHour = _e.getHours();
              this.dayEndMinute = _e.getMinutes();
            } else {
              this.dayStartHour = 8; this.dayStartMinute = 0;
              this.dayEndHour = 20; this.dayEndMinute = 0;
            }

            // ── BUG FIX: Removed the old "past date" check that incorrectly ──
            // set isBlankMessageforTherapistShow=true even when appointments
            // exist for future days in the selected week.
            // The flag is now only set by the availability response directly.

          } else {
            this.isBlankMessageforTherapistShow = true;
            this.dayStartHour = 8; this.dayStartMinute = 0;
            this.dayEndHour = 20; this.dayEndMinute = 0;
          }

        } else {
          this.isHoliday = true;
          this.holidayMessage = result.message;
        }

        // ── Compute week date labels ────────────────────────────────────
        const currentDate = new Date(this.weekcurrentDate.replace(/-/g, '/'));
        const weekStart = moment(currentDate).startOf('week').toDate();
        const weekEnd = moment(currentDate).endOf('week').toDate();

        this.fetchEvents(true);
        this.closeSideBar();
      })
      .catch((httpResponseError) => {
        this.loadingCustom = false;
        this.showErrorMessage(httpResponseError.message);
      });
  }


  private async getSettingInit() {
    this.loading = true;
    await this.settingsService.GetAllSettingsCalenderOnInit()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          if (result?.isSuccess && result.responseModel) {
            this.setRemoteAppintmentTypes(result.responseModel.remoteApointmentTypesResponse);
            this.setRCMConfigurationUrl(result.responseModel.rcmConfigurationUrlResponse);
            this.SetDefaultsettings(result.responseModel.adminSetingResponse);
          }
        });
      }, (err) => { this.loading = false; this.showErrorMessage(err.message); });
  }

  private setRemoteAppintmentTypes(_lst: RemoteAppointmentTypeModel[]) {
    if (_lst?.length > 0) this.remoteAppointmentTypeResponseModel = _lst;
  }

  private setRCMConfigurationUrl(_url: RCMCofigurationUrl) {
    if (_url) { this.patientBrighttreeURL = _url.patientRCMURL; this.salesOrderBrighttreeURL = _url.salesOrderRCMURL; }
  }

  private SetDefaultsettings(s: AdminCustomSettingsResponseModel) {
    if (s) {
      this.daysToShow = s.numOfMonths;
      this.maxDateToDisplay = moment(new Date()).add(this.daysToShow, 'days').toDate();
      this.nextBtnDisabled = this.viewDate < this.maxDateToDisplay ? false : true;
      this.isBillingAddress = s.isBillingAddress;
    }
  }

  private async getGlobalTimeZone() {
    await this.featureGroupService.getSettings(Constants.SettingKeys.TimeZone)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        this.processResult<SettingsResponseModel>(result, () => {
          if (result?.isSuccess && result.responseModel) {
            this.selectedTimeZone = this.timeZoneList.find(x => x.code === result.responseModel.schSettingValue);
          }
        });
      });
  }

  private GetRCMConfigurationUrl() {
    this.loading = true;
    this.featureGroupService.GetRCMConfigurationUrl(Constants.pluginSettingCRMApp)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(true)))
      .subscribe((result: ResultOfT<RCMCofigurationUrl>) => {
        this.processResult<RCMCofigurationUrl>(result, () => {
          if (result.responseModel) {
            this.patientBrighttreeURL = result.responseModel.patientRCMURL;
            this.salesOrderBrighttreeURL = result.responseModel.salesOrderRCMURL;
          }
        });
      }, (err) => this.showErrorMessage(err.message));
  }

  RedirectcalendarActions() {
    if (!this.selectedcalendarActions?.code) return;
    const routes: any = {
      WeekByTherapist: '/admin/calendar/week-therapist-appointments-v1',
      ViewByDate: '/admin/calendar/view-by-date',
      ViewByTherapist: '/admin/calendar/view-therapist-appointments-v1',
    };
    this.router.navigate([routes[this.selectedcalendarActions.code]]);
  }

  async dateOrViewChanged() {
    await this.GetAllTherapistForAppointmentsByTimeZone();
    this.exportData(true);
  }

  SetMinMaxHourForCalander(lst: SchedulerResponseModel[]) {
    let StartHour = this.dayStartHour;
    let EndHour = this.dayEndHour;
    lst.forEach(item => {
      const s = moment(item.start, 'YYYY-MM-DD HH:mm').toDate().getHours();
      const e = moment(item.end, 'YYYY-MM-DD HH:mm').toDate().getHours();
      if (s < StartHour) StartHour = s;
      if (e > EndHour) EndHour = e;
    });
    if (StartHour < this.dayStartHour) this.dayStartHour = StartHour;
    if (EndHour > this.dayEndHour) this.dayEndHour = EndHour;
  }

  async dateChange(): Promise<void> {
    const currentDate = new Date(this.weekcurrentDate.replace(/-/g, '/'));
    const weekStart = moment(currentDate).startOf('week').toDate();
    const weekEnd = moment(currentDate).endOf('week').toDate();
    this.weekStartDate = moment(weekStart).format('MMMM DD');
    this.weekEndDate = moment(weekEnd).format('MMMM DD');
    this.currentYear = moment(weekEnd).format('YYYY');
  }

  get weekcurrentDate(): string {
    return `${this.viewDate.getFullYear()}-${this.viewDate.getMonth() + 1}-${this.viewDate.getDate()}`;
  }

  onNavigateBrightTreeSalesOrderUrl(crmSalesOrderAPPId: string) {
    window.open(
      this.salesOrderBrighttreeURL.replace('{{SalesOrderID}}', Number(crmSalesOrderAPPId)).replace('{{InternalUserID}}', this.brightreeInternalUserId),
      '_blank'
    );
  }

  onNavigateBrightTreePatientUrl(crmPatientId: string) {
    window.open(
      this.patientBrighttreeURL.replace('{{PatientKey}}', Number(crmPatientId)).replace('{{InternalUserID}}', this.brightreeInternalUserId),
      '_blank'
    );
  }

  viewDaysChanged(viewDays: number) { this.viewDays = viewDays; }
  dayHeaderClicked(day: SchedulerViewDay) { }
  hourClicked(hour: SchedulerViewHour) { }
  segmentClicked(action: string, segment: SchedulerViewHourSegment) { }
  eventClicked(action: string, event: CalendarSchedulerEvent) { }

  eventTimesChanged({ event, newStart, newEnd }: SchedulerEventTimesChangedEvent): void {
    const ev = this.events.find(e => e.id === event.id);
    if (ev) { ev.start = newStart; ev.end = newEnd; }
    this.refresh.next();
  }

  closePopup() {
    if (this.accordion?.tabs) this.accordion.tabs.forEach(t => t.selected = false);
  }

  changeWipStatus(event: any) {
    this.wipStatus = event.target.value;
    const result = this.salesOrderStatusCurrent?.filter(i => i.wipStatesName === this.wipStatus) ?? [];
    if (result.length > 0) {
      this.wipStatesId = Number(result[0].wipStatesId);
      this.canStatusIsUpate = true;
      if (this.wipStatus.toLowerCase() === 'complete') {
        const w = this.wipStatusBTMappingResponseModel?.find(x => x.crmWipstatusNameSa.toLowerCase() === 'complete');
        if (w) { this.isBrightreeSystemAppUpdateSetting = w.crmIsUpdateToBrigthree; this.isBrightreeSystemAppUpdate = !w.crmIsUpdateToBrigthree; }
      }
      if (this.wipStatus.toLowerCase() === 'no show') {
        const w = this.wipStatusBTMappingResponseModel?.find(x => x.crmWipstatusNameSa.toLowerCase() === 'noshow');
        if (w) { this.isBrightreeSystemAppUpdateSetting = w.crmIsUpdateToBrigthree; this.isBrightreeSystemAppUpdate = !w.crmIsUpdateToBrigthree; }
      }
    } else {
      this.wipStatesId = 0; this.canStatusIsUpate = false;
    }
  }

  private async GetAllAvailableTherapistByBranchAndDate() {
    let selectBranchString = ''; let selectTherapistString = ''; let selectFacilityString = '';
    this.selectedAppointments = [];
    const branchIds: number[] = [];
    this.selectedbranches.forEach(v => { selectBranchString += v.crmBranchId + ','; branchIds.push(v.crmBranchId); });
    const facilityids: number[] = [];
    this.selectedAppointmentFacilities.forEach(v => { selectFacilityString += v.crmFacilityId + ','; facilityids.push(v.crmFacilityId); });

    const req = new TherapistAppointmentSearchRequestModel();
    req.appointmentDate = this.weekcurrentDate;
    req.crmBranchIds = branchIds; req.crmFacilityiIds = facilityids; req.crmTherapistsId = [];
    req.crmBranchIdsString = selectBranchString; req.crmFacilityiIdsString = selectFacilityString;
    req.crmTherapistsIdString = selectTherapistString; req.crmselectedTimeZone = this.crmselectedTimeZone;

    this.loadingCustom = true;
    await this.facilityService.GetAllAvailableTherapistByBranchAndDateWeekViewDME(req)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loadingCustom = false))
      .toPromise().then((result) => {
        this.loadingCustom = false;
        this.therapistResponseModel = result.responseModel;
        this.selectedTherapists = this.therapistResponseModel[0] ?? null;
        const el = document.getElementsByClassName('material-icons md-32')[0];
        if (el && this.selectedTherapists) {
          el.innerHTML = this.timeZoneList.find(x => x.orgcode === this.selectedTherapists.facilityTimeZone)?.shortName ?? '';
        }
        this.cdr.detectChanges();
      }).catch(err => { this.loadingCustom = false; this.showErrorMessage(err.message); });
  }

  async onCheck() {
    this.isBlankMessageforTherapistShow = false;
    this.redirectedFacilityIdNumber = null;
    this.selectedAppointmentFacilities = new Array<FacilityInfoResponseModel>();
    this.selectedTherapists = null;
  }

  onFilterSearch() {
    if (this.isBranchChange) { this.GetAllAvailableTherapistByBranchAndDate(); this.GetAllTherapistForAppointmentsByTimeZone(); }
    else if (!this.isShowHomeVisit) { this.GetAllTherapistForAppointmentsByTimeZone(); }
    this.isBranchChange = false;
    this.closeSideBar();
  }

  RefreshPage() { this.onFilterSearch(); }

  onBranchChange(event: any) {
    if (event.value) {
      this.isBlankMessageforTherapistShow = false;
      this.redirectedFacilityIdNumber = null;
      this.selectedAppointmentFacilities = new Array<FacilityInfoResponseModel>();
      this.selectedTherapists = null;
      this.isBranchChange = true;
      this.closeSideBar();
    }
  }

  onFacilityChange(event: any) {
    if (event.value) { this.isShowHomeVisit = false; this.GetAllAvailableTherapistByBranchAndDate(); this.selectedTherapists = null; this.closeSideBar(); }
  }

  async onTherapistChange(event: any) {
    if (event.value) this.closeSideBar();
    this.timeZoneShortCode = this.selectedTherapists.facilityTimeZone;
    this.crmselectedTimeZone = this.selectedTherapists.facilityTimeZone;
    this.selectedUser = this.users?.find(x => x.id === event.value.appUserInfoId);
    await this.GetAllTherapistForAppointmentsByTimeZone();
    this.exportData(true);
  }

  onClearFilterSearch() {
    this.isShowHomeVisit = false; this.isBranchChange = false;
    this.selectedTherapists = null;
    this.selectedAppointmentFacilities = new Array<FacilityInfoResponseModel>();
    this.selectedFacilities = new Array<FacilityInfoResponseModel>();
    this.selectedbranches = this.branchResponseModel;
    this.selectedFilterBranches = []; this.selectedClassificationType = [];
  }

  Oncancel() { this._resetNearbyFilter(); }
  onClearFilter() { this._resetNearbyFilter(); }
  private _resetNearbyFilter() {
    this.selectedAppointmentValues = []; this.selectedClassificationType = []; this.selectedFilterBranches = [];
    this.isAllBranchFilterSelected = true; this.isAllClssificationFilterSelected = true; this.isFilterSubmit = false;
    const clone: any[] = [];
    this.origionalNearByPatients?.forEach(v => clone.push(Object.assign({}, v)));
    this.nearByPatients = clone;
  }

  closeSideBar() {
    this.blockSlotPopup = false; this.fillSlotPopup = false;
    this.isRightPanelEnabled = false; this.isRightPanelBlockEnabled = false;
    this.nearByPatients = []; this.blockDesc = '';
    this.selectedFilterBranches = []; this.selectedClassificationType = [];
  }

  private async GetFacilitiesByBranchIds() {
    let crmBranchIdsString = '';
    this.selectedAppointmentFacilities = new Array<FacilityInfoResponseModel>();
    const branchIds: number[] = [];
    this.selectedbranches.forEach(v => { crmBranchIdsString += v.crmBranchId + ','; branchIds.push(v.crmBranchId); });

    const req = new TherapistAppointmentSearchRequestModel();
    req.appointmentDate = this.weekcurrentDate; req.crmBranchIds = branchIds; req.crmBranchIdsString = crmBranchIdsString;

    this.progress.next(true);
    await this.facilityService.GetFacilitiesByBranchIds(req)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        this.facilityResponseModel = result.responseModel;
        if (this.facilityResponseModel.length > 0) {
          this.selectedFacility = this.redirectedFacilityIdNumber
            ? (this.facilityResponseModel.find(x => x.crmFacilityId === this.redirectedFacilityIdNumber) ?? this.facilityResponseModel[0])
            : this.facilityResponseModel[0];
          this.facilityId = this.selectedFacility.crmFacilityId;
          this.isBlankMessageshow = false;
        } else {
          this.isBlankMessageshow = true;
        }
      }).catch(err => this.showErrorMessage(err.message));
  }

  private async getBranches() {
    this.branchResponseModel = this.webStorageService.getUserBrances();
    this.setBranchSettings();
  }

  setBranchSettings() {
    this.branchResponseModel = this.branchResponseModel.filter(x => x.crmBranchId !== 0);
    const sel = this.branchResponseModel.find(x => x.crmBranchId === this.currentUserBranch);
    this.selectedbranches = sel?.crmBranchId
      ? this.branchResponseModel.filter(x => x.crmBranchId === sel.crmBranchId)
      : this.branchResponseModel;
  }

  hourSegmentClick({ date, sourceEvent, userinfo }: any, overlaypanelBlockSlot: OverlayPanel, overlaypanelBlockSlotConextMenu: OverlayPanel) {
    userinfo = this.selectedUser;
    if (date < this.currentDate || date < userinfo.start || date > userinfo.end) return;

    this.isGroupAppointment = userinfo.isGroupAppointmentUser;
    this.facilityInfo = userinfo?.distinctTherapistAvailability.find(
      (x) => date >= moment(x.crmStartTime).add(-1, 'minutes').toDate()
        && date <= moment(x.crmEndTime).add(-1, 'minutes').toDate());

    this.searchDate = date;
    this.searchUser = userinfo;
    const fi = this.getfacilityIdInfo(date, userinfo.therapistAvailability);
    this.facilityId = fi[0];
    this.facilityName = fi[1];
    this.isRemoteAndFacility = fi[2];
    this.remoteFacilityId = fi[3];
    this.remoteFacilityName = fi[4];
    this.isStartFromHomeAddress = fi[5];
    this.isStartFromDefaultFacility = fi[6];
    this.selectedFacilityTimeZone = fi[7];
    this.isRemoteOnly = fi[8];
    this.therapistCustomAvailabilityId = userinfo.therapistCustomAvailabilityId;
    this.therapistCustomDateId = userinfo.therapistCustomDateId;
     var overlappingAvailability = this.findOverlappingAvailability(date, userinfo.therapistAvailability);
    if (overlappingAvailability) {
      this.therapistCustomDateId = overlappingAvailability.custDateID;
    }
    overlaypanelBlockSlot.toggle(event);
    overlaypanelBlockSlotConextMenu.hide();
    this.searchText = '';
  }
  
  private findOverlappingAvailability(date: Date, availabilities: TherapistCustomDatesResponseModel[]): TherapistCustomDatesResponseModel | null {
    if (!availabilities || availabilities.length === 0) return null;

    const targetDate = moment(date);

    return availabilities.find(availability =>
      targetDate.isSameOrAfter(moment(availability.crmStartTime)) &&
      targetDate.isBefore(moment(availability.crmEndTime))
    ) || null;
  }

  getfacilityId(slotStartTime: Date, therapistAvailability: TherapistCustomDatesResponseModel[]): number {
    if (!therapistAvailability) return 0;
    const startDate = moment(slotStartTime).toDate();
    const f = therapistAvailability.find(x => startDate >= moment(x.crmStartTime).add(-1, 'minutes').toDate() && startDate <= moment(x.crmEndTime).add(-1, 'minutes').toDate());
    return f?.facilityId ?? 0;
  }

  getfacilityIdInfo(slotStartTime: Date, therapistAvailability: TherapistCustomDatesResponseModel[]): any {
    if (!therapistAvailability) return [];
    const startDate = moment(slotStartTime).toDate();
    const f = therapistAvailability.find(x => startDate >= moment(x.crmStartTime).add(-1, 'minutes').toDate() && startDate <= moment(x.crmEndTime).add(-1, 'minutes').toDate());
    return f ? [f.facilityId, f.facilityName, f.isRemoteAndFacility, f.remoteFacilityId, f.remoteFacilityName, f.isStartFromHomeAddress, f.isStartFromDefaultFacility, f.facilityTimeZone, f.isRemoteAssistant] : [];
  }

  SearchPatient() { this.selectedAppointmentStatus = null; this.getPatients(this.searchedFacilityid, this.isFacilityselected, this.IsRemoteOrFacility); }
  textChange() { this.showClear = !!(this.searchText && this.searchText !== ''); }
  searchCloseClick() { this.searchText = ''; this.showClear = false; this.selectedAppointmentStatus = null; this.getPatients(this.searchedFacilityid, this.isFacilityselected, this.IsRemoteOrFacility); }

  showScheduleDialog(crmSalesOrderId: any, schAppointmentId: any, crmPatientAllowedOnlyOnMyFacility: any) {
    if (!this.isRemoteAndFacility && this.isRemoteOnly && !crmPatientAllowedOnlyOnMyFacility) { this.showWarningMessage('This patient allowed for facility only.'); return; }
    if (this.isRemoteAndFacility && this.IsRemoteOrFacility === 2 && !crmPatientAllowedOnlyOnMyFacility) { this.showWarningMessage('This patient allowed for facility only.'); return; }
    if (!this.checkCall()) { this.showWarningMessage('Only one patient can be called at one time.'); return; }

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true, closable: false, styleClass: 'book-appt-popup-outer',
      data: { crmSalesOrderId, isRescheduledRequest: schAppointmentId > 0, isAppointment: schAppointmentId > 0, schAppointmentId, isVoidOrder: false, isCancelOrder: false, isCall: false, isScheduleOrder: true, isAppoinmentBookByCalendar: true, crmTherapsitId: this.searchUser.id, crmTherapsitName: this.searchUser.name, crmPractionerId: this.searchUser.practionaerId, crmDeliveryTechnicianId: this.searchUser.deliveryTechnicianId, salesOrderdate: this.searchDate, isRemoteAndFacility: this.isRemoteAndFacility, isFacilityselected: this.isFacilityselected, remoteFacilityId: this.remoteFacilityId, facilityId: this.facilityId, voidFrom: 'A', isGroupAppointment: this.isGroupAppointment, groupAppointmentId: schAppointmentId > 0 ? this.events.find(x => x.meta?.appointmentInfoReponseModel?.id === schAppointmentId)?.meta?.appointmentInfoReponseModel?.appointmentGroupId : 0 },
    });
    this.fillSlotPopup = false;
    ref.onClose.subscribe((session: any) => {
      if (!session) { this.closeSideBar(); this.fetchEvents(true); }
      else if (session.isSession) { this.closeSideBar(); if (session.appointmentDate) { this.viewDate = moment(session.appointmentDate).toDate(); this.GetNextDayAvailability(); } else { this.fetchEvents(true); } }
    });
  }

  async onAppointmentChange(filterPanel: OverlayPanel) {
    this.isFilterSubmit = true;
    if (!this.isAllBranchFilterSelected && this.selectedFilterBranches.length === 0) return;
    if (!this.isAllClssificationFilterSelected && this.selectedClassificationType.length === 0) return;
    if (this.isAllBranchFilterSelected) this.selectedFilterBranches = [];
    if (this.isAllClssificationFilterSelected) this.selectedClassificationType = [];

    let clone: any[] = [];
    this.origionalNearByPatients?.forEach(v => clone.push(Object.assign({}, v)));
    if (!this.isAllBranchFilterSelected) clone = clone.filter(x => this.selectedFilterBranches.map(b => b.crmBranchId).includes(x.crmBranchId));
    if (!this.isAllClssificationFilterSelected) clone = clone.filter(x => this.selectedClassificationType.map(c => c.crmClassificationTypeId).includes(x.crmSalesorderClassificationType));

    if (this.selectedAppointmentValues.length > 0) {
      const filtered: any[] = [];
      this.selectedAppointmentValues.forEach(v => filtered.push(...clone.filter(x => x.crmSalesorderStatus === v)));
      this.nearByPatients = filtered;
    } else { this.nearByPatients = clone; }

    this.isFilterSubmit = false;
    filterPanel.hide();
  }

  getPatients(facilityId: any, isFacilityselected: any, IsRemoteOrFacility: any) {
    this.fillSlotPopup = true; this.isFacilityselected = isFacilityselected; this.searchedFacilityid = facilityId;
    if (this.facilityName === 'Road/Home Appt') { this.selectedApptType = 'RoadHomeVisit'; }
    else if (IsRemoteOrFacility === 1) { this.selectedApptType = 'FacilityVisit'; }
    else if (IsRemoteOrFacility === 2) { this.selectedApptType = 'RemoteSetup'; }
    else { this.selectedApptType = isFacilityselected ? 'FacilityVisit' : (this.isRemoteOnly ? 'RemoteSetup' : 'FacilityVisit'); }

    this.Customloading = true; this.IsRemoteOrFacility = IsRemoteOrFacility;
    this.appointmentService.GetNearByPatientsLicense(facilityId, this.searchText, this.selectedUser.id, this.isStartFromDefaultFacility, this.isStartFromHomeAddress, this.viewDate.toDateString(), this.isBillingAddress, this.selectedApptType)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        this.Customloading = false;
        if (result?.errorCode === 400) { this.isClassificationMapped = false; this.cdr.detectChanges(); return; }
        this.nearByPatients = result.responseModel; this.origionalNearByPatients = result.responseModel;
        this.selectedFilSlotDateTime = this.searchDate;
        if (this.nearByPatients?.length > 0) { this.isRightPanelEnabled = true; this.isRightPanelBlockEnabled = false; this.selectUser = this.searchUser; }
        else { this.isRightPanelEnabled = !!(this.searchText); this.isRightPanelBlockEnabled = false; this.selectUser = null; }
        this.GetClassificationTypesByTherapistId(this.searchUser.id);
        this.cdr.detectChanges();
      }).catch(err => { this.showErrorMessage(err.message); this.Customloading = false; });
  }

  setBlock(therapistCustomAvailabilityId: any) {
    this.blockSlotPopup = true; this.isBlock = true; this.availId = 0;
    this.therapistCustomAvailabilityId = therapistCustomAvailabilityId;
    this.labelFor = 'Block Slot'; this.therapisId = this.searchUser.id; this.selectedtherapist = this.searchUser.name;
    this.isRightPanelBlockEnabled = true; this.isRightPanelEnabled = false;
    const start = this.searchDate; const end = moment(this.searchDate).add(15, 'minutes').toDate();
    this.customStartTime = this.convertTo12HourFormat(start.toTimeString());
    this.customEndTime = this.convertTo12HourFormat(end.toTimeString());
    const ft = this.searchUser.therapistAvailability.filter(x => moment(x.crmStartTime).toDate() <= moment(this.searchDate).toDate() && moment(this.searchDate).toDate() < moment(x.crmEndTime).toDate());
    this.therapistCustomAvailabilityId = ft[0].availID;
    this.updateStartEndTimeOptions(this.convertTo12HourFormat(moment(ft[0].crmStartTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()), this.convertTo12HourFormat(moment(ft[0]?.crmEndTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()));
  }

  setBreak(therapistCustomAvailabilityId: any) {
    const users = this.users?.find(x => x.id === this.searchUser.id);
    const endTime = users?.therapistAvailability?.find(x => x.availID === therapistCustomAvailabilityId)?.crmEndTime;
    this.blockSlotPopup = true; this.isBlock = false; this.availId = 0;
    this.therapistCustomAvailabilityId = therapistCustomAvailabilityId;
    this.labelFor = 'Break Hours'; this.therapisId = this.searchUser.id; this.selectedtherapist = this.searchUser.name;
    this.isRightPanelBlockEnabled = true; this.isRightPanelEnabled = false;
    const start = this.searchDate; let end = moment(this.searchDate).add(30, 'minutes').toDate();
    if (end > moment(endTime).toDate()) end = moment(endTime).toDate();
    this.customStartTime = this.convertTo12HourFormat(start.toTimeString());
    this.customEndTime = this.convertTo12HourFormat(end.toTimeString());
    const ft = this.searchUser.therapistAvailability.filter(x => moment(x.crmStartTime).toDate() <= moment(this.searchDate).toDate() && moment(this.searchDate).toDate() < moment(x.crmEndTime).toDate());
    this.therapistCustomAvailabilityId = ft[0].availID;
    this.updateStartEndTimeOptions(this.convertTo12HourFormat(moment(ft[0].crmStartTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()), this.convertTo12HourFormat(moment(ft[0]?.crmEndTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()));
  }

  showRescheduleDialogPopup() {
    const appointment = this.selectedAppointment;
    if (appointment.crmAppointmentType === 'Facility Visit') this.defaultModeofAppointment = 'facilityvisit';
    else if (appointment.crmAppointmentType === 'Telehealth') this.defaultModeofAppointment = 'remotesetup';
    else if (appointment.crmAppointmentType === 'Home Visit') this.defaultModeofAppointment = 'roadhomevisit';
    if (!this.checkCall()) { this.showWarningMessage('Only one patient can be called at one time.'); return; }
    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true, closable: false, styleClass: 'book-appt-popup-outer',
      data: { crmSalesOrderId: this.selectedAppointment.salesOrderInfo.crmSalesorderId, isRescheduledRequest: true, isAppointment: true, schAppointmentId: appointment.schAppointmentId, isVoidOrder: false, isCancelOrder: false, isCall: false, isScheduleOrder: true, voidFrom: 'A', defaultModeofAppointment: this.defaultModeofAppointment, isGroupAppointment: this.isGroupAppointment, groupAppointmentId: appointment.appointmentGroupId },
    });
    ref.onClose.subscribe((session: any) => {
      this.selectedAppointment = new AppointmentInfoReponseModel();
      if (!session) { this.fetchEvents(true); }
      else if (session.isSession) { if (session.appointmentDate) { this.viewDate = moment(session.appointmentDate).toDate(); this.GetNextDayAvailability(); } else { this.fetchEvents(true); } }
    });
  }

  checkCall(): boolean {
    let check = true;
    this.twillioCallService.twillioCall.pipe(takeUntil(this.unsubscriber)).subscribe((obj: TwilioDeviceObject) => { check = !obj; });
    return check;
  }

  async GetNextDayAvailability() {
    const nextDate = moment(new Date(this.viewDate)).add(1, 'days').toDate();
    this.nextBtnDisabled = nextDate > this.maxDateToDisplay;
    this.isDisabledReassignment = nextDate < this.currentDate;
    this.GetAllAvailableTherapistByBranchAndDate();
    this.GetAllTherapistForAppointmentsByTimeZone();
  }

  convertAppointmentType() {
    const appointment = this.selectedAppointment;
    this.dialougeService.open(ConfirmDialogComponent, { data: { message: `Are you sure you want to change appointment type from ${this.selectedAppointment.schRemoteAppointmentTypeDisplayName} to ${this.convertedRemoteAppointmentType}?` }, header: 'Confirmation' })
      .onClose.subscribe((response: boolean) => {
        if (!response) return;
        this.loadingCustom = true;
        this.appointmentService.ConvertRemoteAppointment(appointment.schAppointmentId, true)
          .pipe(takeUntil(this.unsubscriber), finalize(() => this.loadingCustom = false))
          .subscribe((result: ResultOfT<boolean>) => {
            this.processResult<boolean>(result, () => { this.showSuccessMessage('The appointment type has been changed successfully.'); this.fetchEvents(true); this.exportData(true); this.cdr.detectChanges(); });
          }, err => { this.loadingCustom = false; this.showErrorMessage(err.message); });
      });
  }

  idDateIsPassed(segmentdate: any) {
    this.slotTimeZone = this.timeZoneList.find(x => x.shortName === this.facilityTimeZone);
    const datec = moment(new Date()).tz(this.slotTimeZone.countryName).format('DD-MMM-yyyy HH:mm:ss');
    const currentDate = moment(datec).toDate();
    if (isBefore(segmentdate, currentDate)) return false;
    if (isSameDay(segmentdate, currentDate) || isAfter(segmentdate, currentDate)) return true;
    return false;
  }

  facilityNameLabel(slotStartTime: Date, therapistAvailability: TherapistCustomDatesResponseModel[]): string {
    if (!therapistAvailability || !this.idDateIsPassed(slotStartTime)) return '';
    const startDate = moment(slotStartTime).toDate();
    const f = therapistAvailability.find(x => startDate >= moment(x.crmStartTime).add(-1, 'minutes').toDate() && startDate <= moment(x.crmEndTime).add(-1, 'minutes').toDate());
    if (!f) return '';
    return f.isRemoteAndFacility ? `${f.facilityName} & ${f.remoteFacilityName}` : f.facilityName;
  }

  showDialogPopup(isShow: any, appointment: any, overlaypanelContextMenu: OverlayPanel, overlaypanelBlockSlot: OverlayPanel, isGroupAppointment: boolean, facilityInfo: TherapistCustomDatesResponseModel, bookedGroupAppointmentType: string) {
    this.selectedAppointment = appointment;
    this.isGroupAppointment = isGroupAppointment;
    this.facilityInfo = facilityInfo;
    this.bookedGroupAppointmentType = bookedGroupAppointmentType;
    if (this.selectedAppointment?.crmAppointmentType?.toLowerCase() === 'telehealth' && this.remoteAppointmentTypeResponseModel?.length > 0) {
      const type = this.selectedAppointment.schRemoteAppointmentType?.toLowerCase();
      if (type === 'telemed') {
        const om = this.remoteAppointmentTypeResponseModel.find(x => x.crmRemoteAppointmentType === 'OnlineMeeting');
        if (om) { this.convertedRemoteAppointmentType = om.crmRemoteAppointmentTitle; this.isChangeRemoteAppointmentType = this.selectedAppointment.schWIPStatus?.toLowerCase() === 'booked'; }
        else this.isChangeRemoteAppointmentType = false;
      } else if (type === 'onlinemeeting') {
        const tm = this.remoteAppointmentTypeResponseModel.find(x => x.crmRemoteAppointmentType === 'Telemed');
        if (tm) { this.convertedRemoteAppointmentType = tm.crmRemoteAppointmentTitle; this.isChangeRemoteAppointmentType = this.selectedAppointment.schWIPStatus?.toLowerCase() === 'booked'; }
        else this.isChangeRemoteAppointmentType = false;
      }
    }
    overlaypanelContextMenu.toggle(event);
    overlaypanelBlockSlot.hide();
  }

  onSave() {
    if (!this.blockDesc && this.isBlock) { this.showWarningMessage('Please add description to block slot'); return; }
    if (this.customStartTime && this.customEndTime) {
      const s = moment(this.customStartTime, 'hh:mm A').format('HH:mm');
      const e = moment(this.customEndTime, 'hh:mm A').format('HH:mm');
      if (e === s) { this.showWarningMessage('Start Time & End Time should not be equal'); return; }
      if (e < s) { this.showWarningMessage('End Time should be greater than Start Time'); return; }
    }
    const req = new TherapistCustomAvailabilityResponseModel();
    req.crmBreakEndTimeString = null; req.crmBreakStartTimeString = null; req.crmDescription = this.blockDesc;
    let facilityId = this.facilityId; let remoteFacilityId = this.remoteFacilityId;
    if (this.isBlock) { this.isRoadHomeAppt = this.facilityName === 'Road/Home Appt'; if (this.isRoadHomeAppt && !this.isStartFromDefaultFacility) facilityId = null; }
    else { this.isRoadHomeAppt = this.facilityName === 'Road/Home Appt'; }
    req.crmIsHoliday = true; req.crmIsRecurring = false; req.crmIsRoadShow = this.isRoadHomeAppt;
    req.isRemoteAssistant = false; req.isBlockSlot = true; req.crmRecurringFrequency = 1; req.crmRecurringType = 1;
    req.crmTherapistCustomEndDateString = moment(this.searchDate).format('yyyy/MM/DD');
    req.crmTherapistCustomEndTimeString = moment(this.customEndTime, 'hh:mm A').format('HH:mm');
    req.crmTherapistCustomStartDateString = moment(this.searchDate).format('yyyy/MM/DD');
    req.crmTherapistCustomStartTimeString = moment(this.customStartTime, 'hh:mm A').format('HH:mm');
    req.crmTherapistId = this.therapisId; req.crmTherpistCustomAvailabilityId = this.therapistCustomAvailabilityId;
    req.customId = this.therapistCustomDateId; req.crmIsExactDay = false; req.isOffice = false;
    req.modifiedByUserInfoId = this.loggedInUserId; req.isFullDay = false;
    req.isStartFromDefaultFacility = this.isStartFromDefaultFacility; req.isStartFromHomeAddress = this.isStartFromHomeAddress;
    req.crmFacilityId = facilityId; req.isRemoteAndFacility = this.isRemoteAndFacility;
    req.selectedFacilityTimeZone = this.selectedFacilityTimeZone;
    req.isBookedFromCalendar = true; req.isAddManageAvailabilityChanged = false; req.isAddBlockAvailabilityChanged = true;
    req.availablityType = this.isBlock ? 'Block' : 'Break'; req.therapistBlockAvailId = this.availId;
    if (this.isRemoteAndFacility) req.crmRemoteFacilityId = remoteFacilityId;
    let day = moment(this.searchDate).toDate().getDay();
    day = day === 0 ? Math.pow(2, 6) : Math.pow(2, day - 1);
    req.crmCustomDays = day.toString();
    if (this.isBlock) { if (this.availId === 0) this.SetAvailability(req); else this.UpdateAvailability(req); }
    else { if (this.availId === 0) this.SetBreakHours(req); else { req.isBreakHoursUpdate = true; this.UpdateBrekHours(req); } }
  }

  SetAvailability(r: TherapistCustomAvailabilityResponseModel) {
    this.loadingBlockSlotBrakHours = true; this.isButtonDisabled = true; this.progress.next(true);
    r.crmTherpistCustomAvailabilityId = this.therapistCustomAvailabilityId; r.isBookedFromCalendar = true;
    r.isAddManageAvailabilityChanged = false; r.isAddBlockAvailabilityChanged = true; r.availablityType = this.isBlock ? 'Block' : 'Break'; r.operationType = 'Add';
    this.therapistService.addBlockSlot(r).pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).toPromise().then(res => { this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; if (res.isSuccess && !res.message) { this.showSuccessMessage('Availability saved successfully'); this.closeSideBar(); this.cdr.detectChanges(); this.fetchEvents(true); } else { this.cdr.detectChanges(); this.showWarningMessage(res.message); } }).catch(err => { this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.cdr.detectChanges(); this.showErrorMessage(err.message); });
    this.loadingCustom = false;
  }

  UpdateAvailability(r: TherapistCustomAvailabilityResponseModel) {
    this.loadingBlockSlotBrakHours = true; this.isButtonDisabled = true; this.progress.next(true);
    this.therapistService.updateBlock(r).pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).toPromise().then(res => { this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.blockSlotPopup = false; if (res.isSuccess && !res.message) { this.showSuccessMessage('Availability updated successfully'); this.closeSideBar(); this.cdr.detectChanges(); this.fetchEvents(true); } else { this.cdr.detectChanges(); this.showWarningMessage(res.message); } }).catch(err => { this.blockSlotPopup = false; this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.cdr.detectChanges(); this.showErrorMessage(err.message); });
    this.loadingCustom = false;
  }

  SetBreakHours(r: TherapistCustomAvailabilityResponseModel) {
    this.loadingBlockSlotBrakHours = true; this.isButtonDisabled = true; this.progress.next(true);
    this.therapistService.setBreakHours(r).pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).toPromise().then(res => { this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.blockSlotPopup = false; if (res.isSuccess && !res.message) { this.showSuccessMessage('Break Hours added successfully'); this.closeSideBar(); this.cdr.detectChanges(); this.fetchEvents(true); } else { this.cdr.detectChanges(); this.showWarningMessage(res.message); } }).catch(err => { this.blockSlotPopup = false; this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.cdr.detectChanges(); this.showErrorMessage(err.message); });
    this.loadingCustom = false;
  }

  UpdateBrekHours(r: TherapistCustomAvailabilityResponseModel) {
    this.isButtonDisabled = true; this.loadingBlockSlotBrakHours = true; this.progress.next(true);
    this.therapistService.updateBreakHours(r).pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).toPromise().then(res => { this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.blockSlotPopup = false; if (res.isSuccess && !res.message) { this.showSuccessMessage('Break Hours updated successfully'); this.closeSideBar(); this.cdr.detectChanges(); this.fetchEvents(true); } else { this.cdr.detectChanges(); this.showWarningMessage(res.message); } }).catch(err => { this.blockSlotPopup = false; this.isButtonDisabled = false; this.loadingBlockSlotBrakHours = false; this.cdr.detectChanges(); this.showErrorMessage(err.message); });
    this.loadingCustom = false;
  }

  editSlotCalled(therapistCustomAvailabilityId: any, availId: any, faciltiytimeZone: any, therapistCustomDateId: any) {
    this.therapistService.EditSlot(availId, faciltiytimeZone, therapistCustomDateId).pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false)).subscribe((result: ResultOfT<TherapistEditBlockResponseModel>) => {
      this.processResult<TherapistEditBlockResponseModel>(result, () => {
        if (result?.responseModel) {
          this.labelFor = 'Block Slot'; this.isBlock = true; this.blockSlotPopup = true;
          this.selectedtherapist = result.responseModel.therapistName; this.facilityId = result.responseModel.facilityId;
          this.isRightPanelBlockEnabled = true; this.isRightPanelEnabled = false; this.blockDesc = result.responseModel.desc;
          this.searchDate = result.responseModel.crmCustomDate;
          this.customStartTime = moment(result.responseModel.crmStartTime).format('hh:mm a');
          this.customEndTime = moment(result.responseModel.crmEndTime).format('hh:mm a');
          this.availId = availId; this.therapistCustomAvailabilityId = therapistCustomAvailabilityId;
          this.therapisId = result.responseModel.therapistId; this.selectedFacilityTimeZone = faciltiytimeZone;
          this.updateStartEndTimeOptions(this.convertTo12HourFormat(moment(result.responseModel.therapistStartTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()), this.convertTo12HourFormat(moment(result.responseModel.therapistEndTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()));
          this.cdr.detectChanges();
        }
      });
    }, err => this.showErrorMessage(err.message));
  }

  removeSlotCalled(therapistCustomAvailabilityId: any, availId: any, data: any) {
    this.dialougeService.open(ConfirmDialogComponent, { data: { message: 'Are you sure you want to remove blocked slot?' }, header: 'Confirmation' }).onClose.subscribe((response: boolean) => {
      if (!response) return;
      this.therapistService.removeSlotWithTimeZone(availId, data).pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false)).subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => { if (result?.responseModel) { this.showSuccessMessage('Availability removed successfully'); this.fetchEvents(true); this.cdr.detectChanges(); } });
      });
    });
  }

  editBreakCalled(therapistCustomAvailabilityId: any, availId: any, facilityTimeZone: any, therapistCustomDateId: any) {
    this.StartTimeSelections = [...this.TimeSelectionList]; this.EndTimeSelections = [...this.TimeSelectionList];
    this.therapistService.EditBreak(availId, facilityTimeZone, therapistCustomDateId).pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false)).subscribe((result: ResultOfT<TherapistEditBlockResponseModel>) => {
      this.processResult<TherapistEditBlockResponseModel>(result, () => {
        if (result?.responseModel) {
          this.blockSlotPopup = true; this.isBlock = false; this.labelFor = 'Add Break Hours';
          this.selectedtherapist = result.responseModel.therapistName; this.isRightPanelBlockEnabled = true; this.isRightPanelEnabled = false;
          this.blockDesc = result.responseModel.desc; this.searchDate = result.responseModel.crmCustomDate;
          this.customStartTime = moment(result.responseModel.crmStartTime).format('hh:mm a');
          this.customEndTime = moment(result.responseModel.crmEndTime).format('hh:mm a');
          this.availId = availId; this.therapistCustomAvailabilityId = therapistCustomAvailabilityId;
          this.selectedFacilityTimeZone = facilityTimeZone; this.therapisId = result.responseModel.therapistId; this.facilityId = result.responseModel.facilityId;
          this.updateStartEndTimeOptions(this.convertTo12HourFormat(moment(result.responseModel.therapistStartTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()), this.convertTo12HourFormat(moment(result.responseModel.therapistEndTime, 'YYYY-MM-DD HH:mm').toDate().toTimeString()));
          this.cdr.detectChanges();
        }
      });
    }, err => this.showErrorMessage(err.message));
  }

  removeBreakCalled(therapistCustomAvailabilityId: any, availId: any, data: any) {
    this.dialougeService.open(ConfirmDialogComponent, { data: { message: 'Are you sure you want to remove break hours?' }, header: 'Confirmation' }).onClose.subscribe((response: boolean) => {
      if (!response) return;
      this.therapistService.removeBreak(availId).pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false)).subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => { if (result?.responseModel) { this.cdr.detectChanges(); this.fetchEvents(true); } });
      }, err => this.showErrorMessage(err.message));
    });
  }

  exportPDF() {
    this.loading = true;
    this.exportData(true);
    setTimeout(() => {
      if (!this.exportDataRes || this.exportDataRes.length === 0) {
        this.showWarningMessage('No Appointments for selected Date.');
        return;
      }
      this.generatePDFWithPdfMake();
    }, 2000);
  }

  private generatePDFWithPdfMake() {
    try {
      // Prepare the table data
      const tableData = this.prepareTableData();
      const appointmentCountContent = this.prepareAppointmentCountContent();

      // Define the document structure with proper typing
      const docDefinition: any = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 60],
        content: [
          // Header
          {
            columns: [
              {
                text: `${this.therapistName}`,
                style: 'header',
                width: '*'
              },
              {
                text: `${this.weekStartDate} - ${this.weekEndDate}, ${this.currentYear}`,
                style: 'dateRange',
                width: 'auto',
                alignment: 'right'
              }
            ],
            margin: [0, 0, 0, 20]
          },

          // Facility info
          ...appointmentCountContent,

          // Table
          {
            table: {
              headerRows: 1,
              widths: ['10%', '17%', '10%', '15%', '8%', '10%', '13%', '10%', '7%'],
              body: tableData
            },
            layout: {
              hLineWidth: function (i: number, node: any) {
                return (i === 0) ? 0 : (i === 1) ? 2 : 1;
              },
              hLineColor: function (i: number, node: any) {
                return (i === 1) ? '#B0A3EF' : '#868686';
              },
              vLineWidth: function (i: number, node: any) {
                return 0;
              }
            }
          }
        ],
         styles: {
        header: {
          fontSize: 18,
          bold: true,
          color: '#6F64A7'
        },
        dateRange: {
          fontSize: 14,
          bold: true,
          color: '#3E3E3E'
        },
        appointmentCount: {
          fontSize: 12,
          color: '#3E3E3E'
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: '#3E3E3E',
          alignment: 'justify'

        },
        tableCell: {
          fontSize: 7,
          color: '#3E3E3E'
        }
      },
      defaultStyle: {
        fontSize:10
      }
    };

      const fileName = this.selectedTherapists.appUserFullname + ".pdf";
      pdfMake.createPdf(docDefinition).download(fileName);
      this.loading = false;
    } catch (error) {
      console.error('Error generating PDF:', error);
      this.showErrorMessage('Error generating PDF. Please try again.');
      this.loading = false;
    }
  }

  private prepareAppointmentCountContent(): any[] {
    if (!this.exportAppointmentCnt || this.exportAppointmentCnt.length === 0) {
      return [];
    }

    const countText = this.exportAppointmentCnt
      .slice(0, 3)
      .map(item => `${item.appointmentTitle}: ${item.appointmentCount}`)
      .join(' | ');

    return [{
      text: countText,
      style: 'appointmentCount',
      alignment: 'left',
      margin: [0, 5, 0, 15]
    }];
  }

private prepareTableData(): any[] {
  const headerRow = [
    { text: 'Appointment Date', style: 'tableHeader' },
    { text: 'Time', style: 'tableHeader' },
    { text: 'Sales Order Id', style: 'tableHeader' },
    { text: 'Patient Name / Patient Id', style: 'tableHeader' },
    { text: 'Block / Break', style: 'tableHeader' },
    { text: 'Classification', style: 'tableHeader' },
    { text: 'Location', style: 'tableHeader' },
    { text: 'Appointment Type', style: 'tableHeader' },
    { text: 'Status', style: 'tableHeader' }
  ];

  const dataRows = this.exportDataRes.map(appointment => [
    { 
      text: moment(appointment.dtStart).format('MM/DD/YYYY'), 
      style: 'tableCell' 
    },
    { 
      text: `${appointment.crmPatientTimeZone?.toUpperCase() || 'EST'}`, 
      style: 'tableCell' 
    },
    { 
      text: appointment.soId?.toString() || '', 
      style: 'tableCell' 
    },
    { 
      text: appointment.patientName || '', 
      style: 'tableCell' 
    },
    {
      text: appointment.availabilityType || '',
      style: 'tableCell'
    },
    { 
      text: appointment.classification || '', 
      style: 'tableCell' 
    },
    { 
      text: this.formatLocation(appointment.location), 
      style: 'tableCell' 
    },
    { 
      text: appointment.apptType || '', 
      style: 'tableCell' 
    },
    { 
      text: appointment.status || '', 
      style: 'tableCell' 
    }
  ]);

  return [headerRow, ...dataRows];
}

  private formatLocation(location: string): string {
    if (!location) return '';

    const parts = location.split(/[,\n]/).map(part => part.trim()).filter(part => part.length > 0);

    const maxLength = 50;
    const formatted = parts.join(', ');

    return formatted.length > maxLength ?
      formatted.substring(0, maxLength) + '...' :
      formatted;
  }

  exportData(isRefresh: boolean) {
    this.loading = true; this.therapistName = this.selectedTherapists.appUserFullname;
    this.theraistAppointmentService.GetTherapistAppointmentForExportWeekViewDME(this.selectedTherapists.appUserInfoId, this.viewDate.toDateString(), isRefresh)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).toPromise()
      .then((result) => {
        this.processResult<SchedulerResponseModelForExportFinal>(result, () => {
          this.loading = false;
          if (result.responseModel?.schedulerResponseModelForExportDbs) {
            this.exportDataRes = result.responseModel.schedulerResponseModelForExportDbs;
            this.exportAppointmentCnt = result.responseModel.appointmentCountForExportPDFs;
          }
        });
      }).catch(err => { this.loading = false; this.showErrorMessage(err.message); });
  }

  exportCSV() {
    this.loading = true;
    this.theraistAppointmentService.GetTherapistAppointmentsExportCSVWeekViewDME(this.selectedTherapists.appUserInfoId, this.viewDate.toDateString())
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;'); a.download = this.selectedTherapists.appUserFullname + '.csv';
        document.body.appendChild(a); a.target = '_blank'; a.href = URL.createObjectURL(new Blob([result], { type: result.type }));
        document.body.removeChild(a); a.click();
      }, err => this.showErrorMessage(this.getErrorMessage(err)));
  }

  convertTo12HourFormat(time24: string) {
    const [h, m] = time24.split(':').map(Number);
    return `${((h % 12) || 12).toString().padStart(2, '0')}:${m.toString().padStart(2, '0')} ${h < 12 ? 'am' : 'pm'}`;
  }

  updateEndTimeOptions(selectedStartTime: string) {
    this.EndTimeSelections = this.StartTimeSelections.slice(this.StartTimeSelections.findIndex(t => t.name === selectedStartTime) + 1);
  }

  updateStartEndTimeOptions(start: string, end: string) {
    if (!start || !end) return;
    const si = this.TimeSelectionList.findIndex(t => t.name === start);
    const ei = this.TimeSelectionList.findIndex(t => t.name === end);
    this.StartTimeSelections = this.TimeSelectionList.slice(si, ei + 1);
    this.EndTimeSelections = this.TimeSelectionList.slice(si, ei + 1);
    if (this.customStartTime) this.EndTimeSelections = this.StartTimeSelections.slice(this.StartTimeSelections.findIndex(t => t.name === this.customStartTime) + 1);
  }

  LegendsClick() { this.LegendsisActive = !this.LegendsisActive; $('body').toggleClass('show-legends'); }
  LegendsClickClose() { this.LegendsisActive = !this.LegendsisActive; $('body').removeClass('show-legends'); }

  private async GetClassificationTypesByTherapistId(id: number) {
    await this.appointmentService.GetClassificationTypesByTherapistId(id).pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).toPromise()
      .then((result) => { this.processResult<FilterClassificationTypeResponseModel[]>(result, () => { if (result.isSuccess && result.responseModel) this.filterClassificationList = result.responseModel; }); })
      .catch(err => this.showErrorMessage(err.message));
  }

  public isFutureDate(date: Date): boolean {
    return moment(date).startOf('day').isSameOrAfter(moment().startOf('day'));
  }
}